import React from 'react';
import { useNavigate } from 'react-router-dom';
import { portfolio } from '../data/portfolio';
import { portfolioPage as P } from '../data/pages';
import PageHero from '../components/PageHero';
import SectionHeading from '../components/SectionHeading';
import Reveal from '../components/Reveal';
import SafeImage from '../components/SafeImage';
import CTA from '../sections/CTA';

export default function PortfolioPage() {
  const navigate = useNavigate();
  return (
    <>
      <PageHero center art="mosaic" title={P.hero.title} text={P.hero.text} primary={{ label: P.hero.button, onClick: () => navigate('/contact') }} />
      <section className="section">
        <div className="container">
          <SectionHeading row title={P.title} text={P.text} />
          <div className="pgrid">
            {portfolio.map((p, i) => (
              <Reveal key={p.name} delay={(i % 2) * 80}>
                <article className="pcard" tabIndex={0}>
                  <SafeImage src={p.image} alt={p.name} seed={i} />
                  <div className="pcard__over">
                    <span>{p.category}</span>
                    <h3>{p.name}</h3>
                  </div>
                </article>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
      <CTA title="Let's Start Something Great Together" highlight="Great" text="Tell us about your project and we'll show you how we can help." />
    </>
  );
}
